import React, { useCallback, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { notBlank } from "../util/ext";
import Paper from "@material-ui/core/Paper";
import { lensPath, mergeRight, omit, set } from "ramda";
import Grid from "@material-ui/core/Grid";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { useUserUpdate } from "./userServices";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles(theme => ({
  form: {
    marginTop: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },

  errorContainer: {
    marginTop: theme.spacing(1),
    fontWeight: "bold",
    color: theme.palette.error.main,
  },
}));

const initialState = {
  password: "",
  confirm: "",
};

const ChangePasswordDialog = props => {
  const { open, onCancel, onOk, user } = props;
  const classes = useStyles();

  const [changePassword, setChangePassword] = useState(initialState);
  const [errors, setErrors] = useState([]);

  const updateUser = useUserUpdate();
  const handleApply = useCallback(async () => {
    if (
      notBlank(changePassword.password) &&
      notBlank(changePassword.confirm) &&
      changePassword.password === changePassword.confirm
    ) {
      const update = mergeRight(
        { password: changePassword.password },
        omit(["organizations", "profile"], user),
      );

      try {
        await updateUser.mutateAsync({
          resourceIds: { id: user.userId },
          data: update,
        });
        setChangePassword(initialState);
        setErrors([]);
        onOk();
      } catch (err) {
        setErrors([err.message]);
      }
    } else {
      setErrors(["Password Confirmation does not match."]);
    }
  }, [changePassword, user, updateUser, onOk]);

  const handleClose = useCallback(() => {
    setChangePassword(initialState);
    setErrors([]);
    onCancel();
  }, [onCancel]);

  const handleTextChange = path => event => {
    const value = event.target.value;
    setChangePassword(prev => set(lensPath(path), value, prev));
  };

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={handleClose}
      aria-labelledby="new-program-dialog-title"
    >
      <DialogTitle id="add-user-roles-dialog-title">
        Change Password
      </DialogTitle>
      <DialogContent>
        {notBlank(errors) && (
          <Box className={classes.errorContainer}>
            {errors.map(message => (
              <div key={Math.random()}>{message}</div>
            ))}
          </Box>
        )}
        <Paper>
          <Box className={classes.form}>
            <Grid spacing={2} container>
              <Grid item md={12}>
                <TextField
                  label="New Password"
                  fullWidth
                  type={showPassword ? "text" : "password"}
                  value={changePassword.password}
                  onChange={handleTextChange(["password"])}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment>
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Confirm Password"
                  fullWidth
                  type={showPassword ? "text" : "password"}
                  value={changePassword.confirm}
                  onChange={handleTextChange(["confirm"])}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment>
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleApply} color="primary">
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePasswordDialog;
